let is_home_page = false;
if (document.body.classList.contains('home')) {
  is_home_page = true;
}

// ScrollOut();

var rellax = new Rellax('.rellax', {
  speed: -4,
});

document.addEventListener('DOMContentLoaded', () => {
  $('.nav.nav-header > div > ul > li.current-page-ancestor').find('.sub-menu').addClass('active');
  $('.nav.nav-header > div > ul > li.current-page-ancestor .sub-menu a').each(function () {
    if (window.location.pathname == $(this).attr('href')) {
      $(this).addClass('custom-current-menu-item');
    }
  });
});

require('./components/header-animation');
require('./components/yt-lightbox');
require('./components/application-slider');
require('./components/misc-scripts');
require('./components/header-hover');
require('./components/mobile-submenu');
require('./components/misc-home-solutions');
require('./components/homepage-slider');
